import React, {createContext} from 'react';

export const requestData = {
  createRequestFromDashboard: false,
  setCreateRequestFromDashboard: () => {},
}
export const RequestContext = createContext(requestData);
